import { Component, OnInit, Input, ChangeDetectorRef, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";
import { TableService } from "@app/shared/services/table.service";
import { NbDialogRef, NbDialogService, NbToastrService } from "@nebular/theme";
import { DatePipe } from '@angular/common';
import { ConfirmDialogComponent } from "../../confirm-dialog/confirm-dialog.component";
import { ReminderService } from "@app/shared/services/reminder-service.service";

@Component({
  selector: "ngx-info-dialog",
  templateUrl: "./info-dialog.component.html",
  styleUrls: ["./info-dialog.component.scss"],
})
export class InfoDialogComponent implements OnInit,AfterViewInit {

  currentUser;
  constructor(
    public ref: NbDialogRef<InfoDialogComponent>,
    private router: Router,
    private tableService: TableService,
    private toasterService: NbToastrService,
    private dialogService: NbDialogService,
    private cd:ChangeDetectorRef,
    private datePipe:DatePipe,
    private reminderService: ReminderService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem("userData"));
  }

  @Input() text = "";
  @Input() title = "";
  @Input() dialogType = "";
  @Input() notification: any;
  @Input() plainAlert = false;
  @Input() onCloseEvnet = false;
  loading = false;
  buttonText = "Cancel";



  actionItems = [
     { icon: { icon: 'python', pack: 'edit' } }
  ];

  snoozeTime;
  triggerTime;
  triggerDate;
  expiryDate = new Date();
  firstTimeOpen ;

  ngOnInit(){

    this.firstTimeOpen = localStorage.getItem("isFirstTime")

    this.reminderService.reminderUpdated$.next(this.notification);

    if (this.dialogType == 'reminder') {
      this.buttonText = 'View Reminders';
    }
    if(this.notification?.reminderDetails.dueDate){
      this.triggerTime = this.datePipe.transform(this.notification.reminderDetails.dueDate, 'shortTime');
      this.triggerDate = this.datePipe.transform(this.notification.reminderDetails.dueDate, 'MM/dd/yyyy');
    }
    if(this.notification?.reminderDetails.dateTime){
      this.triggerTime = this.datePipe.transform(this.notification.reminderDetails.dateTime, 'shortTime');
      this.triggerDate = this.datePipe.transform(this.notification.reminderDetails.dateTime, 'MM/dd/yyyy');
    }
    setTimeout(() => {
      let localCheck = localStorage.getItem('dashBoardReminder')
      if(localCheck){
        this.onCloseEvnet = true
      }
    },500)
    this.reminderService.reminderUpdated$.subscribe((r) => {
      this.notification = r;
    })
    this.cd.detectChanges();
  }

  ngAfterViewInit(): void {
    this.tableService.runCustomStyling();
  }

  // snoozeModelClosed(){
  //   this.reminderService.reminderUpdated$.subscribe((r) => {
  //     this.notification = r;
  //   })
  // }

  onLinkClicked() {
    this.router.navigate([
      "pages/tables/dynamic/" +
      this.notification.tableId +
      "/" +
      this.notification.tableName +
      "/" +
      this.notification.resourceId +
      "/" +
      "/To Do",
    ]);
    this.ref.close();
  }

  closeIt() {
    this.loading = false;
    this.ref.close();
  }

  onClose() {
    this.ref.close();
  }

  onFirstTimeReminder() {
    this.ref.close();
    const element = <HTMLElement>document.querySelector('.notification_dropdown');
    element.click();
  }

  remindNavigate(notification) {
    this.router.navigate([`/pages/tables/dynamic/${notification.tableId}/${notification.tableName}/${notification.resourceId}`]);
  }

  markComplete(notification){
    this.reminderService.markComplete(notification);
    this.ref.close();
  }

  stopRecurring(reminder: any) {
    if (reminder && reminder?.frequency) {
      const dialogData = {
        title: "Are you Sure?",
        text: `Are you sure you want stop recurring for this reminder ?`,
      };
      this.dialogService
        .open(ConfirmDialogComponent, { context: dialogData })
        .onClose.subscribe((res: any) => {
          if (res) {
            let id = '';

            if (reminder.reminderDetails._id) {
              id = reminder.reminderDetails._id;
            }

            if (reminder.reminderDetails.notificationId) {
              id = reminder.reminderDetails.notificationId;
            }
            this.tableService.updateNotes(id, { frequency: null }).subscribe(
              (res: any) => {
                if (res.statusCode === 200) {
                  this.toasterService.success(res.message, "Success");
                  this.stopRecurringClose('stopRecurring',reminder);
                } else {
                  this.toasterService.danger(res.message, "Error");
                  this.stopRecurringClose(false,'failed');
                }
              },
              (error) => {
              }
            );
          }
        });
    }
  }

  stopRecurringClose(value: any, reminder: any) {
    this.ref.close({ status: value, data: reminder });
  }

  markCompleteClose(value,notification) {
    this.loading = false;
    this.ref.close({status:value,data:notification});
  }

  openSnoozeModal(reminder) {
    this.reminderService.openSnoozeModal(reminder , 0 , this.ref);
  }

  openReminderModal(reminder){
    this.reminderService.openReminderModal2(reminder).subscribe(value => {
      this.notification.reminderDetails.dueDate = value["dueDate"];
      this.notification.reminderDetails.notes = value["notes"];
      this.notification.reminderDetails.details = value["details"];
    });
  }
}
